/**
 * Pure selection-state helpers for the AI Recruiter Console.
 *
 * Extracted so they can be unit-tested without any Apollo / React wiring —
 * the only frontend test pattern this repo supports for component-tree logic
 * (mirrors InvoiceAging/utils/__tests__).
 */

/**
 * Intersection: keep only the ids that appear in both `selectedIds` AND the
 * job order's currently-rendered `visibleIds` list. Order is preserved from
 * `visibleIds`.
 *
 * Fix B: the mutation payload can only ever contain pipelineEntryIds that are
 * currently rendered rows of the active job order. Declined rows that remain
 * in `selectedIds` due to the cache-and-network stale-render window are
 * dropped here before they can reach BulkActionBar.
 */
export function intersectWithVisible(
  selectedIds: string[],
  visibleIds: string[],
): string[] {
  const selectedSet = new Set(selectedIds);
  return visibleIds.filter((id) => selectedSet.has(id));
}

/**
 * Prune: remove from `selectedIds` any id that no longer appears in the full
 * set of live pipeline-entry ids across all job orders on the active tab.
 *
 * Fix A: after a refetch drops declined rows, any lingering selected id is
 * removed, keeping the bar-count and Undo payload honest.
 *
 * Returns `null` when the array is unchanged (same length) so the caller can
 * skip a no-op setState.
 */
export function pruneToLiveIds(
  selectedIds: string[],
  liveIds: Set<string>,
): string[] | null {
  const pruned = selectedIds.filter((id) => liveIds.has(id));
  if (pruned.length === selectedIds.length) return null;
  return pruned;
}
